import {AppDataActions} from './types';
import {buildAsyncActionsCreator, createAsyncActionExecutor, isAuthErrorResponse} from '../asyncUtils';
import {requestSettings, requestVersion} from './api';
import {messageNetworkError} from '../message';

const HOME_LOGIN = '/#base/login';

export const appDataLoadSettingsActionsCreator = buildAsyncActionsCreator(AppDataActions.LOAD_SETTINGS);
export const appDataLoadSettings = createAsyncActionExecutor(appDataLoadSettingsActionsCreator, requestSettings, {
  handleAuthErrorEnabled: false,
  showError: false,
  failureFunction: (dispatch, error) => {
    dispatch(appDataLoadSettingsActionsCreator.failure(error));
    if (error.toString().indexOf('TypeError') > -1 || error.status === 504 || error.status === 404) {
      window.location.assign(HOME_LOGIN);
    } else if (!isAuthErrorResponse(error)) {
      dispatch(messageNetworkError(error));
    }
  },
});

export const appDataLoadVersionActionsCreator = buildAsyncActionsCreator(AppDataActions.LOAD_VERSION);
export const appDataLoadVersion = createAsyncActionExecutor(appDataLoadVersionActionsCreator, requestVersion);
